"use strict";
import React, { useState, useEffect, useCallback, useRef } from "react";
import _ from 'lodash';
import { apiHelper } from "../lib/ApiHelper.js";
import * as moment from 'moment';
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import "@ag-grid-community/styles/ag-theme-balham.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { RangeSelectionModule } from "@ag-grid-enterprise/range-selection";
import { RichSelectModule } from '@ag-grid-enterprise/rich-select';
import { ModuleRegistry } from "@ag-grid-community/core";
import DuplicateAlert from "../Landing_Page/DuplicateAlert";
ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    RangeSelectionModule,
    RichSelectModule
]);
import { LicenseManager } from "@ag-grid-enterprise/core";
import './gridstyle.css';
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-058820}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Penguin_Random_House_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{InventoryHub}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{InventoryHub}_need_to_be_licensed___{InventoryHub}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_April_2025}____[v3]_[01]_MTc0MzcyMTIwMDAwMA==a87b1efc2ee2da35884b94c846d80314");

export default function ReprintBulkTemp(props) {
    const gridApi = useRef(null);        
    const [duplicateAlert, setDuplicateAlert] = useState(false)
    const [updateMasterRow, setUpdateMasterRow] = useState(true);
    const [duplicateRow, setDuplicateRow] = useState([]);
    const [masterRowData, setMasterRowData] = useState([]);
    const [ISBNLoading, setISBNLoading] = useState(false);
    const [bulkLoading, setBulkLoading] = useState(false);
    const [rowData, setactualRowData] = useState([]);
    const [managerOptions, setManagerOptions] = useState([]);
    const [sLocOptions, setSLocOptions] = useState([]);
    const [VersionOptions, setVersionOptions] = useState([]);
    const [BatchCode, setBatchCode] = useState([]);
    const gridOptions = {
        defaultColDef: {
            resizable: true,
            flex: 1,
            filter: true,
            minWidth: 120,
            floatingFilter: true,
            editable: true,
        },
        pagination: true,
        paginationPageSize: 50,
        enableRangeSelection: true,
        enableFillHandle: true,
        suppressDragLeaveHidesColumns: true, // ✅ stops column from being dragged away (out of the grid)
        suppressColumnMoveAnimation: false,  // optional: shows animation when interchanging
    };

    const updateAdditionlaCVR = async (data, value) => {
        if (value == false) {
            const masterRow = rowData.find(row => row.isbn === data.isbn && row.additionalRow == true);
            if (!masterRow) {
                const modification = "none";
                const newRow = { ...data, additionalRow: true, rowId: null };
                await callUpdate([newRow], modification);
                await fetchBulkData();
                let newMasterRow = [...masterRowData, _.cloneDeep(newRow)];
                setMasterRowData(newMasterRow);
                setUpdateMasterRow(true);
            }
        } else {
            const modification = "";
            await callUpdate([data], modification);
            const newData = await rowData.filter(row => !(row.rowId == data.rowId));
            let masterValue = await masterRowData.filter(row => !(row.rowId == data.rowId));
            masterValue = await _.cloneDeep(masterValue);
            setMasterRowData(masterValue);
            setRowData(newData);
            setUpdateMasterRow(true);
        }
    }


    const onClose = () => {
        setDuplicateAlert(prev => !prev);
    }

    const addtnlCheckHandle = (e) => {
        setUpdateMasterRow(false);
        setISBNLoading(true);
        const { data, value } = e.target.param;
        updateAdditionlaCVR(data, value);
        setISBNLoading(false);
    }
    const checkCellChange = (p) => {
        let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
        if (originalValue == undefined || originalValue == null)
            return false;
        return originalValue[p?.colDef?.field] != p.value;
    }

    const onCellValueChanged = useCallback((event) => {
        const { data } = event;
        const modification = "update";
        callUpdate([data], modification);
    }, []);

    const callUpdate = async (reprints, modification) => {
        try {
            const payLoad = { reprints: reprints, modification: modification };
            await apiHelper.inventoryPostCall("updateReprintTempTable", payLoad);
        } catch (e) {
            console.error(e);
        }
    }

    const validateData = () => {
        for (const row of rowData) {
            if (!row.isbn
                ||
                !((row.printBindQty && row.printBindQty != 0) || (row.comments && row.comments.trim() != ""))
            ) {
                return { isValid: false, message: "Please check the data for possible screenError" };
            }
        }
        return { isValid: true };
    }

    const bulkUpdate = async () => {
        if (duplicateRow.length > 0) {
            onClose();
            return;
        }
        setISBNLoading(true);
        try {
            const validation = validateData();
            if (!validation.isValid) {
                if (validation?.message)
                    alert(validation.message);
                return;
            }
            const res = await apiHelper.inventoryPostCall("setBulkReprints", rowData);
            if (res == true)
                clearReprint();
        } catch (e) {
            console.error(e);
        } finally {
            setISBNLoading(false);
        }
    }

    const getRowStyle = params => {

        if (duplicateRow.find(item => item.isbn == params.data.isbn && item.additionalRow == params.data.additionalRow)) {
            const dups = duplicateRow.find(item => item.isbn == params.data.isbn && item.additionalRow == params.data.additionalRow);
            if (dups)
                return { color: "red" };
        }
        
    };
    const currencyFormatter = (currency, sign) => {
        var value = parseFloat(currency);
        if (isNaN(value) || value == null || value == undefined) {
            value = 0;
        }

        // Convert to a string and split into integer and decimal parts
        const [integerPart, decimalPart] = value.toFixed(2).split('.');

        // Format the integer part with commas
        var formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        // Combine formatted integer part and decimal part
        var formatted = `${formattedIntegerPart}.${decimalPart}`;

        return sign + formatted;
    }

    const columnDefs = [
        {
            headerName: "ISBN", headerClass: "grey-background", cellClass: "grey-background cell-text-left", field: "isbn", width: 110, pinned: "left", editable: false, tooltipValueGetter: (p) =>"ISBN : " + p.value
        },
        {
            headerName: "Title", headerClass: "grey-background ", cellClass: "grey-background cell-text-left", field: "title", editable: false, tooltipValueGetter: (p) => "Title : " + p.value
        },
        {
            headerName: "Addtl Cvrs/Jkts", headerClass: "header-text-centre", cellClass: "input-bulk-cell", field: "additionalRow", suppressFillHandle: true,
            cellRenderer: (params) => (
                <input type="checkbox" checked={params.value
                } className="mt-1 ml-4" onChange={(e) => addtnlCheckHandle({ target: { value: e, param: params } })} disabled={ISBNLoading} />
            ),
            editable: false,
            tooltipValueGetter: (p) =>
                "Addtl Cvrs/Jkts : " + p.value
        },
        {
            headerName: "New US Price",headerClass: "header-text-right", field: "newUSPrice",editable: true,filter: "agNumberColumnFilter",cellDataType: "number",
            cellEditorParams: {
                min: 0,
            },
            valueFormatter: params => currencyFormatter(params.value, "$"),
            tooltipValueGetter: (p) => {
                if (masterRowData.length > 0) {
                    let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
                    originalValue = originalValue ? originalValue[p.colDef.field] : p.value;
                    return ("New US Price : " + originalValue);
                }
                return ("New US Price : " + p.value);
            },
            cellClassRules: {
                "screenError-back": (params) => { return (params.value && params.value < 0) },
                "cell-changed": (params) => {
                    return !(params.value && params.value < 0) && checkCellChange(params);
                }
            }, cellClass:"cell-text-right"
        },
        {
            headerName: "New Can Price", headerClass: "header-text-right", field: "newCANPrice", editable: (params) => !params.data.additionalRow,filter: "agNumberColumnFilter",cellDataType: "number",
            cellClassRules: {
                "screenError-back": (params) => { return (params.value && params.value < 0) },
                "cell-changed": (params) => {
                    return !(params.value && params.value < 0) && checkCellChange(params);
                }
            },
            cellEditorParams: {
                min: 0,
            },
            valueFormatter: params => currencyFormatter(params.value, "$"),
            tooltipValueGetter: (p) => {
                if (masterRowData.length > 0) {
                    let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
                    originalValue = originalValue ? originalValue[p.colDef.field] : p.value;
                    return ("New Can Price : " + originalValue);
                }
                return ("New Can Price : " + p.value)
            }, cellClass: "cell-text-right"
        },
        {
            headerName: "Batch Code", headerClass: "" ,field: "batchCode", cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: BatchCode,
            },
            editable: (params) => !params.data.additionalRow,
            tooltipValueGetter: (p) => {
                if (masterRowData.length > 0) {
                    let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
                    originalValue = originalValue ? originalValue[p.colDef.field] : p.value;
                    return ("Batch Code : " + originalValue);
                }
                return ("Batch Code : " + p.value)
            }, cellClassRules: {
                "cell-changed": (params) => {
                    return !(params.value && params.value < 0) && checkCellChange(params);
                }
            }, cellClass: "cell-text-left"
        },
        {
            headerName: "Current Price", headerClass: "grey-background header-text-right", field: "currentPrice", editable: false,  cellClass: "grey-background cell-text-right",
            tooltipValueGetter: (p) => {
                if (masterRowData.length > 0) {
                    let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
                    originalValue = originalValue ? originalValue[p.colDef.field] : p.value;
                    return ("Current Price : " + originalValue);
                }
                return ("Current Price : " + p.value)
            }
        },
        {
            headerName: "Cvr Qty", headerClass: "header-text-right", field: "coverQty", cellEditorParams: {min: 0,}, cellDataType: "number",
            valueFormatter: params => {
                if (!params.value || params.value === '') {
                    return 0;
                };
            },
            tooltipValueGetter: (p) => {
                if (masterRowData.length > 0) {
                    let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
                    originalValue = originalValue ? originalValue[p.colDef.field] : p.value;
                    return ("Cvr Qty : " + originalValue);
                }
                return ("Cvr Qty : " + p.value)
            },
            cellClassRules: {
                "screenError-back": (params) => {
                    return (params.value && params.value < 0);
                },
                "cell-changed": (params) => {
                    return !(params.value && params.value < 0) && checkCellChange(params);
                }
            }, cellClass: "cell-text-right"
        },
        {
            headerName: "Cvr Del Date", headerClass: "header-text-right", field: "coverDelDate", filter: 'agDateColumnFilter', cellDataType: "date", valueFormatter: function (params) {
                if (!params.value)
                    return null;
                return moment(params.value).format('MM-DD-yyyy');
            },
            suppressFillHandle: true,
            tooltipValueGetter: (p) => {
                if (masterRowData.length > 0) {
                    let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
                    originalValue = originalValue ? originalValue[p.colDef.field] : p.value;
                    return ("Cvr Del Date : " + originalValue);
                }
                return ("Cvr Del Date : " + p.value)
            },
            cellClassRules: {
                "cell-changed": (params) => {
                    return !(params.value && params.value < 0) && checkCellChange(params);
                }
            }, cellClass: "cell-text-right"
        },
        {
            headerName: "P/B Qty", headerClass: "header-text-right", field: "printBindQty", cellEditorParams: {min: 0,}, cellDataType: "number",
            cellClassRules: {
                "screenError-back": (params) => {
                    return ((!params?.value || params.value < 1) && (!params.data.comments || params?.data?.comments.trim() === ""));
                }
            },
            tooltipValueGetter: (p) => {
                if (masterRowData.length > 0) {
                    let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
                    originalValue = originalValue ? originalValue[p.colDef.field] : p.value;
                    return ("P/B Qty : " + originalValue);
                }
                return ("P/B Qty : " + p.value)
            }
            , cellClassRules: {
                "cell-changed": (params) => {
                    return !(params.value && params.value < 0) && checkCellChange(params);
                }
            }, cellClass: "cell-text-right"
        },
        {
            headerName: "P/B Date", headerClass: "header-text-right", field: "printBindDate", filter: 'agDateColumnFilter', cellDataType: "date", valueFormatter: function (params) {
                if (!params.value)
                    return null;
                return moment(params.value).format('MM-DD-yyyy');
            },
            suppressFillHandle: true,
            tooltipValueGetter: (p) => {
                if (masterRowData.length > 0) {
                    let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
                    originalValue = originalValue ? originalValue[p.colDef.field] : p.value;
                    return ("P/B Date : " + originalValue);
                }
                return ("P/B Date : " + p.value)
            },
            cellClassRules: {
                "cell-changed": (params) => {
                    return !(params.value && params.value < 0) && checkCellChange(params);
                }
            }, cellClass: "cell-text-right"
        },
        {
            headerName: "Comments", headerClass: "header-text-right", field: "comments", cellDataType: "text",
            cellEditorParams: {
                maxLength: 50,
            },
            tooltipValueGetter: (p) => {
                if (masterRowData.length > 0) {
                    let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
                    originalValue = originalValue ? originalValue[p.colDef.field] : p.value;
                    return ("Comments : " + originalValue);
                }
                return ("Comments : " + p.value)
            },
            cellClassRules: {
                "screenError-back": (params) => {
                    return ((!params?.value || params.value === "") && (!params.data.coverQty || params?.data?.coverQty < 0));
                },
                "cell-changed": (params) => {
                    return !(params.value && params.value < 0) && checkCellChange(params);
                }
            },cellClass: "cell-text-left"
        },
        {
            headerName: "Sloc", headerClass: "header-text-right", field: "sloc", cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: sLocOptions,
            },
            editable: (params) => !params.data.additionalRow,
            tooltipValueGetter: (p) => {
                if (masterRowData.length > 0) {
                    let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
                    originalValue = originalValue ? originalValue[p.colDef.field] : p.value;
                    return ("Sloc : " + originalValue);
                }
                return ("Sloc : " + p.value)
            },
            cellClassRules: {
                "cell-changed": (params) => {
                    return !(params.value && params.value < 0) && checkCellChange(params);
                }
            }, cellClass: "cell-text-right"
        },
        {
            headerName: "Version", headerClass: "cell-text-left", field: "version", cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: VersionOptions,
            },
            editable: (params) => !params.data.additionalRow,
            tooltipValueGetter: (p) => {
                if (masterRowData.length > 0) {
                    let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
                    originalValue = originalValue ? originalValue[p.colDef.field] : p.value;
                    return ("Version : " + originalValue);
                }
                return ("Version : " + p.value)
            },
            cellClassRules: {
                "cell-changed": (params) => {
                    return !(params.value && params.value < 0) && checkCellChange(params);
                }
            }, cellClass: "cell-text-left"
        },
        {
            headerName: "CHG", headerClass: "header-text-centre", field: "changes", cellClass: " input-bulk-cell", tooltipValueGetter: (p) => {
                if (masterRowData.length > 0) {
                    let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
                    originalValue = originalValue ? originalValue[p.colDef.field] : p.value;
                    return ("CHG : " + originalValue);
                }
                return ("CHG : " + p.value)
            }
            ,
            cellClassRules: {
                "cell-changed": (params) => {
                    return !(params.value && params.value < 0) && checkCellChange(params);
                }
            }
        },
        {
            headerName: "HP", headerClass:"header-text-centre", field: "hp", cellClass: " input-bulk-cell", tooltipValueGetter: (p) => {
                if (masterRowData.length > 0) {
                    let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
                    originalValue = originalValue ? originalValue[p.colDef.field] : p.value;
                    return ("HP : " + originalValue);
                }
                return ("HP : " + p.value)
            }
            ,
            cellClassRules: {
                "cell-changed": (params) => {
                    return !(params.value && params.value < 0) && checkCellChange(params);
                }
            }
        },
        {
            headerName: "RI", headerClass: "header-text-centre", field: "ri", cellClass: " input-bulk-cell", tooltipValueGetter: (p) => {
                if (masterRowData.length > 0) {
                    let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
                    originalValue = originalValue ? originalValue[p.colDef.field] : p.value;
                    return ("RI : " + originalValue);
                }
                return ("RI : " + p.value)
            },
            cellClassRules: {
                "cell-changed": (params) => {
                    return !(params.value && params.value < 0) && checkCellChange(params);
                }
            }
        },
        {
            headerName: "PA", headerClass: "header-text-centre",
            field: "printAhead", cellClass: " input-bulk-cell", tooltipValueGetter: (p) => {
                if (masterRowData.length > 0) {
                    let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
                    originalValue = originalValue ? originalValue[p.colDef.field] : p.value;
                    return ("PA : " + originalValue);
                }
                return ("PA : " + p.value)
            },
            cellClassRules: {
                "cell-changed": (params) => {
                    return !(params.value && params.value < 0) && checkCellChange(params);
                }
            }
        },
        {
            headerName: "Prod Man",
            headerClass: "",
            field: "productionManager",
            cellEditor: "agRichSelectCellEditor",
            allowTyping: true,
            cellEditorParams: {
                values: managerOptions,
                searchType: "match",
                allowTyping: true,
                filterList: true,
                highlightMatch: true,
                valueListMaxHeight: 220
            }
            , tooltipValueGetter: (p) => {
                if (masterRowData.length > 0) {
                    let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
                    originalValue = originalValue ? originalValue[p.colDef.field] : p.value;
                    return ("Prod Man : " + originalValue);
                }
                return ("Prod Man : " + p.value)
            },
            cellClassRules: {
                "cell-changed": (params) => {
                    return !(params.value && params.value < 0) && checkCellChange(params);
                }
            },cellClass: "cell-text-left"
        },
        {
            headerName: "Import Comment", headerClass: "", field: "ImportComment", cellDataType: "text",
            cellEditorParams: {
                maxLength: 250,
            }, tooltipValueGetter: (p) => {
                if (masterRowData.length > 0) {
                    let originalValue = masterRowData?.find(row => row.rowId === p.data.rowId);
                    originalValue = originalValue ? originalValue[p.colDef.field] : p.value;
                    return ("Import Comment : " + originalValue);
                }
                return ("Import Comment : " + p.value)
            }
            ,
            cellClassRules: {
                "cell-changed": (params) => {
                    return !(params.value && params.value < 0) && checkCellChange(params);
                }
            }, cellClass: "cell-text-left"
        },
        {
            headerName: "Action",
            field: "isbn",
            filter: false,
            cellRenderer: (params) => (
                <div onClick={() => removeRow(params)} style={{ color: 'red', cursor: 'pointer' }} disabled={ISBNLoading}>
                    Remove
                </div>
            ),
            width: 60, editable: (params) => !params.data.additionalRow,
            tooltipField: "Delete Row"
        },
    ];

    const removeRow = useCallback((params) => {
  /*      const data = rowData.filter(row => !(row.rowId == params.data.rowId));
        console.info(rowData.filter(row => !(row.rowId == params.data.rowId)));
        console.info(data);
        console.info(params.data.isbn);*/
        callUpdate([params.data], "");
       
     //   const data = rowData.filter(row => !(row.rowId == params.data.rowId));
       // setRowData(data);

        setactualRowData(prevRowData => {
            let updatedRowData;
            updatedRowData = prevRowData.filter(row => !(row.rowId == params.data.rowId));
            let duplicates = [];
            const seen = new Set();
         
            updatedRowData.forEach(i => {
                const key = `${i.isbn}-${i.additionalRow}`;

                // If already seen, push to duplicates
                if (seen.has(key)) {
                    duplicates.push(i);
                } else {
                    // Mark as seen

                    seen.add(key);
                }
            })

            setDuplicateRow(duplicates);

            if (duplicates.length > 0) {
                
                const dupOnly = updatedRowData.filter(i => (duplicates.some(u => u.isbn == i.isbn && u.additionalRow == i.additionalRow)));
                const uniqOnly = updatedRowData.filter(i => (!duplicates.some(u => u.isbn == i.isbn && u.additionalRow == i.additionalRow)));
                const finalArray = dupOnly.concat(uniqOnly);
                return finalArray;
               
            } else {
              
                return updatedRowData;
            }
           
        });


    }, []);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            uploadDoc(file);
        }
    }

    const LoadISBNTitle = async () => {
        fetchReprintFromIsbnList();
    }

    const uploadDoc = async (file) => {
        try {
            //setScreenError(null);
            setBulkLoading(true);
            const res = await apiHelper.inventoryFilePostCall("uploadReprint", file, props.upn);                        
            if (res?.success) {                
                await fetchBulkData();
            } else {
                console.error(res?.error ?? 'Unknown error occurred try again.');
                //setScreenError(res?.error ?? 'Unknown screenError occurred try again.')
            }
        } catch (e) {
            console.error("Upload failed", e);
        } finally {
            setBulkLoading(false);
        }
    }

    const clearReprint = async () => {
        setISBNLoading(true);
        const res = await apiHelper.inventoryPostCall("clearTempBulkReprint", { value: props.upn });
        if (res) {
           // setDuplicateRow([]);
            await setRowData([]);
        }
        setISBNLoading(false);
    }

    const fetchReprintFromIsbnList = async () => {
        setISBNLoading(true);
        try {
            if (props?.ISBNList || props.ISBNList.count > 0) {
                const res = await apiHelper.inventoryPostCall("getReprintsExistingISBN", { ISBNDTO: props.ISBNList, upn: props.upn });
                if (res && res?.uploadData) {
                    let row = _.cloneDeep(res.uploadData);
                    await setMasterRowData(row);
                }
                if (res && res?.masterData) {
                    if (res.masterData?.productionmanager)
                        setManagerOptions(res.masterData.productionmanager.map(i => i.prodManager).filter(Boolean));
                    if (res.masterData?.batchCode && res.masterData.batchCode.length > 0)
                        setBatchCode(res.masterData.batchCode.map(i => i.batchCode).filter(Boolean));
                    if (res.masterData?.getSloc)
                        setSLocOptions(res.masterData.getSloc.map(i => i.sloc).filter(Boolean));
                    if (res.masterData.getVersion)
                        setVersionOptions(res.masterData.getVersion.map(i => i.version).filter(Boolean));

                    const filteredData = res.uploadData.filter(i => i.audience === props.audience);
                  
                        
                    setRowData(filteredData);
                    //checkForDuplicates(filteredData);
                    if (res?.uploadData.length > 0)
                        return true;
                }
            }
        } catch (e) {
            console.error(e);
            return false;
        } finally {
            setISBNLoading(false);
        }
    }
    const checkForDuplicates = (list) => {
    
            const duplicates = [];
            const seen = new Set();

        list.forEach(item => {
            const key = `${item.isbn}-${item.additionalRow}`;

            // If already seen, push to duplicates
            if (seen.has(key)) {
                duplicates.push(item);
            } else {
                // Mark as seen
             
                seen.add(key);
            }
        })
        setDuplicateRow(duplicates);

    }

    useEffect(() => {
        fetchBulkData();
    }, [])

    const setRowData = (item) => {
        let duplicates = [];
        const seen = new Set();
        if (item == [] || item == null || item.length < 1) {
          
            setDuplicateRow([]);
            setactualRowData([]);
            return;
        }
        item.forEach(i => {
            const key = `${i.isbn}-${i.additionalRow}`;

            // If already seen, push to duplicates
            if (seen.has(key)) {
                duplicates.push(i);
            } else {
                // Mark as seen

                seen.add(key);
            }
        })
      
        setDuplicateRow(duplicates);
       
        if (duplicates.length > 0) {
      
            const dupOnly = item.filter(i => (duplicates.some(u => u.isbn == i.isbn && u.additionalRow == i.additionalRow)));
            const uniqOnly = item.filter(i => (!duplicates.some(u => u.isbn == i.isbn && u.additionalRow == i.additionalRow)));
            const finalArray = dupOnly.concat(uniqOnly);
            setactualRowData(finalArray);
        } else {
            setactualRowData(item);
        }
    }



    const fetchBulkData = async () => {
        setBulkLoading(true);
        try {
            const res = await apiHelper.inventoryPostCall("getBultTebleReprint", { value: props.upn });
            if (updateMasterRow && res && res?.uploadData) {
                let row = _.cloneDeep(res.uploadData);
             
                await setMasterRowData(row);
            }
            if (res && res?.masterData) {

                if (res.masterData?.productionmanager)
                    setManagerOptions(res.masterData.productionmanager.map(i => i.prodManager).filter(Boolean));
                if (res.masterData?.batchCode && res.masterData.batchCode.length > 0)
                    setBatchCode(res.masterData.batchCode.map(i => i.batchCode).filter(Boolean));
                if (res.masterData?.getSloc)
                    setSLocOptions(res.masterData.getSloc.map(i => i.sloc).filter(Boolean));
                if (res.masterData.getVersion)
                    setVersionOptions(res.masterData.getVersion.map(i => i.version).filter(Boolean));

                const filteredData = res.uploadData.filter(i => i.audience === props.audience);
                
                setRowData(filteredData);
             
                if (res?.uploadData.length > 0)
                    return true;
            }
            return false;
        } catch (e) {
            console.error("Fetch bulk reprint failed", e);
            return false;
        } finally {
            setBulkLoading(false);
        }
    };

    const onGridReady = async (params) => {
        gridApi.current = params.api;
    };

    return (
        <>
            {props.reprintActive && (
                <div className="bulkRpt">
                    <div className={`modal fade show d-block ${props?.audience === "US" ? "modal-us": ""}`}  tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog modal-xl" role="document">
                            <div className="modal-content">
                                <div className="modal-header pt-1">
                                    <h5 className="modal-title">Reprint Data Update</h5> <input type="file" id="Reprint-File" name="Reprint-File" accept=".csv, .xls, .xlsx" onChange={handleFileChange} style={{ width: "220px", marginLeft: "auto" }} disabled={ISBNLoading || bulkLoading} />
                                    {duplicateRow.length > 0 && <span style={{ color: "red" }} className="ml-2"> There are {duplicateRow.length} duplicates below. Please correct.  </span>}
                                    <button type="button" className="close" onClick={props.onClose} aria-label="Close" >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>

                                {/*{screenError && <div className='error'>{screenError}</div> }*/}
                                <div className="modal-body">
                                    <div className="ag-theme-quartz" style={{ width: "100%", height: "100%" }}>
                                        <AgGridReact
                                            rowData={rowData}
                                            columnDefs={columnDefs}
                                            gridOptions={gridOptions}
                                            onGridReady={onGridReady}
                                            onCellValueChanged={onCellValueChanged}
                                            getRowStyle={getRowStyle}
                                        />
                                    </div>
                                </div>
                                {/* loading sign*/}
                                {(ISBNLoading || bulkLoading) && <div className="loader" />}
                                <div className="modal-footer">
                                    <button type="button" className="ISBNSubmit mr-2" onClick={LoadISBNTitle} disabled={ISBNLoading || bulkLoading}>Load ISBN Title</button>
                                    <button type="button" className="ISBNSubmit mr-2" onClick={clearReprint} disabled={ISBNLoading || bulkLoading || rowData.length < 1 }>Clear</button>

                                    <button type="button" className="ISBNSubmit" onClick={bulkUpdate} disabled={ISBNLoading || bulkLoading || rowData.length < 1}>Submit</button>
                                    <button type="button" className="ISBNSubmit" onClick={props.onClose} >Close</button>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </div>
            )}
            {duplicateAlert && <div className="popup-content"  >
                <DuplicateAlert onClose={onClose} duplicateRow={duplicateRow}></DuplicateAlert>
            </div>}
        </>
    );
}
